import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import { useConditionalContext } from "./ConditionalContext";
import { IconButton } from "@mui/material";

export function ButtonChangeCondition(props: { delta: number }) {
  const { changeSelectedCondition, selectedCondition, conditions } = useConditionalContext();

  if (selectedCondition === undefined || conditions === undefined) {
    return <></>;
  }

  const canGoUp = selectedCondition < conditions.length - 1;
  const canGoDown = selectedCondition > 0;

  function changeCondition() {
    if (selectedCondition === undefined || conditions === undefined) {
      return;
    }

    let targetConditionId = selectedCondition + props.delta;
    if (targetConditionId > conditions.length - 1) {
      targetConditionId = conditions.length - 1;
    }
    if (targetConditionId < 0) {
      targetConditionId = 0;
    }

    changeSelectedCondition(targetConditionId);
  }

  if (props.delta > 0) {
    return (
      <IconButton disabled={!canGoUp} onClick={changeCondition}>
        <NavigateNextIcon />
      </IconButton>
    );
  } else {
    return (
      <IconButton disabled={!canGoDown} onClick={changeCondition}>
        <NavigateBeforeIcon />
      </IconButton>
    );
  }
}
